import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getLocalStorageItem } from "../Utils/Index";
function PublicAuth(props) {
  const isAuthenticated = () => {
    const user = getLocalStorageItem("access_token");
    return user;
  };

  return isAuthenticated() ? (
    <>
      {" "}
      <Navigate to="/dashboard" />
    </>
  ) : (
    <Outlet />
  );
}
export default PublicAuth;
